import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  SEARCH_CLAIM_MEMBERS_REQUEST: '',
  SEARCH_CLAIM_MEMBERS_SUCCESS: '',
  SEARCH_CLAIM_MEMBERS_FAILURE: '',

  GET_CLAIM_MEMBER_ATTACHMENTS_REQUEST: '',
  GET_CLAIM_MEMBER_ATTACHMENTS_SUCCESS: '',
  GET_CLAIM_MEMBER_ATTACHMENTS_FAILURE: '',

  GET_CLAIM_MEMBER_AUTH_DETAIL_REQUEST: '',
  GET_CLAIM_MEMBER_AUTH_DETAIL_SUCCESS: '',
  GET_CLAIM_MEMBER_AUTH_DETAIL_FAILURE: '',
};

types = setStoreTypeValues(types, 'claimMember');

export default types;
